import React from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Highlight, Text} from "@pg-design/text-module";
import {truncate} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";

import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {ArticleDetailPerson} from "../../actions/IArticleDetail";

interface Props {
    person: ArticleDetailPerson;
}

export const PersonDescription = (props: Props) => {
    const {person} = props;
    const link = person.is_featured ? rpAppLink.article.author.detail({authorId: person.id, authorSlug: person.slug}) : undefined;

    const handleClick = () => {
        if (link) {
            window.open(link, "_blank");
        }
    };

    return (
        <div className={cx(personDescriptionBase, !!link && hoverStyle)} onClick={handleClick}>
            <Image width="130px" height="130px" className={personImg} src={getThumbnailLink(person.image_url, 130, 130)} alt={person.name} />
            <div>
                <Text align="inherit" as="div" variant="headline_5" mb={1.5}>
                    {link ? (
                        <a href={link} target="_blank">
                            <Highlight>{person.name}</Highlight>
                        </a>
                    ) : (
                        <Highlight>{person.name}</Highlight>
                    )}
                </Text>
                {person.description ? (
                    <Text align="inherit" color="var(--colors-gray-800)" variant="body_copy_2">
                        {truncateToSentence(person.description, 400)}
                    </Text>
                ) : null}
            </div>
        </div>
    );
};

export const truncateToSentence = (value: string, length: number) => {
    const resultToLastSentence = truncate(value, {
        length: length,
        separator: /(\. )+/,
        omission: "."
    });

    if (resultToLastSentence.length > 0) {
        return resultToLastSentence;
    }

    return truncate(value, {
        length: length,
        separator: /,? +/,
        omission: String.fromCharCode(8230)
    });
};

const personImg = css({
    flexGrow: 0,
    flexShrink: 0,
    mb: 2,

    md: {
        mr: 2
    }
});

const personDescriptionBase = css({
    display: "block",
    p: 1.5,
    textAlign: "center",

    md: {
        display: "flex",
        alignItems: "center",
        textAlign: "left"
    }
});

const hoverStyle = css({
    _hover: {
        cursor: "pointer"
    }
});
import React from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Highlight, Text} from "@pg-design/text-module";
import {truncate} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";

import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {ArticleDetailPerson} from "../../actions/IArticleDetail";

interface Props {
    person: ArticleDetailPerson;
}

export const PersonDescription = (props: Props) => {
    const {person} = props;
    const link = person.is_featured ? rpAppLink.article.author.detail({authorId: person.id, authorSlug: person.slug}) : undefined;

    const handleClick = () => {
        if (link) {
            window.open(link, "_blank");
        }
    };

    return (
        <div className={cx(personDescriptionBase, !!link && hoverStyle)} onClick={handleClick}>
            <Image width="130px" height="130px" className={personImg} src={getThumbnailLink(person.image_url, 130, 130)} alt={person.name} />
            <div>
                <Text align="inherit" as="div" variant="headline_5" mb={1.5}>
                    {link ? (
                        <a href={link} target="_blank">
                            <Highlight>{person.name}</Highlight>
                        </a>
                    ) : (
                        <Highlight>{person.name}</Highlight>
                    )}
                </Text>
                {person.description ? (
                    <Text align="inherit" color="var(--colors-gray-800)" variant="body_copy_2">
                        {truncateToSentence(person.description, 400)}
                    </Text>
                ) : null}
            </div>
        </div>
    );
};

export const truncateToSentence = (value: string, length: number) => {
    const resultToLastSentence = truncate(value, {
        length: length,
        separator: /(\. )+/,
        omission: "."
    });

    if (resultToLastSentence.length > 0) {
        return resultToLastSentence;
    }

    return truncate(value, {
        length: length,
        separator: /,? +/,
        omission: String.fromCharCode(8230)
    });
};

const personImg = css({
    flexGrow: 0,
    flexShrink: 0,
    mb: 2,

    md: {
        mr: 2
    }
});

const personDescriptionBase = css({
    display: "block",
    p: 1.5,
    textAlign: "center",

    md: {
        display: "flex",
        alignItems: "center",
        textAlign: "left"
    }
});

const hoverStyle = css({
    _hover: {
        cursor: "pointer"
    }
});
